export const NAME = 'labels';


/** WEBPACK FOOTER **
 ** ./src/modules/labels/constants.js
 **/